import type {
  Response,
  ActivityResponse,
} from '@/lib/apollo/query/getActivitiesForUser/query'
import { parseDate } from '@/utils/date'

import type { TransformedActivityData, TransformedData } from './types'

export const toTransformedActivityData = (
  activity: ActivityResponse,
): TransformedActivityData => ({
  ...activity,
  type: activity.type ?? undefined,
  sectionName: activity.sectionName ?? undefined,
  createdAt: parseDate(activity.createdAt),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getActivitiesForUser,
        results: response.getActivitiesForUser.results.map(toTransformedActivityData),
      }
